export const createCarouselOuterStyles = ({
  slideNumber,
  slidesAmount,
  edgeSlidesPadding = 0,
  visiblePartLeft = 0,
  visiblePartRight = 0,
  lastItemPercentageWidth,
  hidden,
}: {
  slideNumber: number;
  slidesAmount: number;
  edgeSlidesPadding?: number;
  visiblePartLeft?: number;
  visiblePartRight?: number;
  lastItemPercentageWidth?: number;
  hidden?: boolean;
}) => {
  let style = {};
  style = {
    minWidth: hidden ? 0 : '100%',
    height: '100%',
  };

  style = {
    ...style,
    marginRight: `-${visiblePartRight / 2}px`,
    paddingRight: `${visiblePartRight / 2 + edgeSlidesPadding}px`,
    marginLeft: `${-visiblePartLeft / 2 - edgeSlidesPadding}px`,
    paddingLeft: `${visiblePartLeft / 2}px`,
  };

  // only-of-type
  if (slidesAmount === 1) {
    style = {
      ...style,
      padding: hidden ? 0 : `0 ${edgeSlidesPadding}px`,
      margin: 0,
    };
  }
  // first-of-type
  if (slideNumber === 0 && slidesAmount !== 1) {
    style = {
      ...style,
      marginLeft: 0,
      paddingLeft: `${edgeSlidesPadding}px`,
      marginRight: `calc(-${(visiblePartRight + visiblePartLeft) /
        2}px + ${edgeSlidesPadding}px)`,
      paddingRight: `${(visiblePartRight + visiblePartLeft) / 2}px`,
    };
  }
  // last-of-type
  if (slideNumber === slidesAmount - 1 && slidesAmount !== 1) {
    style = {
      ...style,
      paddingRight: `${edgeSlidesPadding}px`,
      marginLeft: `calc(-${(visiblePartLeft + visiblePartRight) /
        2}px - ${edgeSlidesPadding}px)`,
      paddingLeft: `${(visiblePartLeft + visiblePartRight) / 2}px`,
    };

    if (lastItemPercentageWidth && lastItemPercentageWidth !== 100) {
      style = {
        ...style,
        minWidth: `${lastItemPercentageWidth}%`,
      };
    }
  }

  return style;
};
